import { Dialog, Props as DialogProps } from '~/components/Dialog/Dialog';
import { Button } from '~/components/Button/Button';

type Props = Omit<DialogProps, 'children'> & {
  onConfirm: () => void;
  isLoading: boolean;
};

export function ConfirmResetDialog({ isLoading, isOpen, onClose, onConfirm }: Props) {
  return (
    <Dialog isOpen={isOpen} onClose={onClose}>
      <Dialog.Title>Är du helt säker?</Dialog.Title>

      <Dialog.Text>
        Genom att hämta viktklasser på nytt, så kommer alla eventuellt ifyllda kvalgränser att nollställas.
      </Dialog.Text>

      <Button.Group align="right">
        <Button variant="secondary" onClick={onClose}>
          Avbryt
        </Button>
        <Button variant="destructive" onClick={onConfirm} isLoading={isLoading}>
          Ja, fortsätt
        </Button>
      </Button.Group>
    </Dialog>
  );
}
